export enum Command {
    UPDATE_GOAL = 'coaching:updateGoal',
    OPEN_CHAT = 'coaching:openChat',
    OPEN_NEW_TRANSCRIPT_DIALOG = 'coaching:openNewTranscriptDialog',
    OPEN_TRANSCRIPT = 'coaching:openTranscript',
}
